/* src/app/components/common/sidenav-container/sidenav-container.component.scss */
::ng-deep .mat-drawer-inner-container {
  overflow: hidden !important;
}
/*# sourceMappingURL=sidenav-container.component.css.map */
